import { Injectable } from '@angular/core';

@Injectable()
export class GAPCalculator {
    calculatePmt(GAPAmount, annualInterestRate, terms) {
        const i = parseFloat(annualInterestRate) / 1200;
        const n = parseFloat(terms);

        const p = parseFloat(GAPAmount);
        const pmt = this.pmt(i, n, -p);

        return pmt.toFixed(2);
    }

    pmt(i, n, p) {
        return i * p * Math.pow((1 + i), n) / (1 - Math.pow((1 + i), n));
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/gap-calculator.ts